export class FaultCount {
  AllCount: number;
}
